/**
 * Process install steps are already in the page HTML.
 * This only switches the three series. It does not rebuild or hide an older layout.
 */
(function () {
  'use strict';

  if (!document.documentElement || document.documentElement.dataset.leavesProcessSteps === '1') return;
  document.documentElement.dataset.leavesProcessSteps = '1';

  function wire(root) {
    root.addEventListener('click', function (event) {
      var tab = event.target.closest('.leaves-process-steps__tab');
      if (!tab || !root.contains(tab)) return;
      var id = tab.getAttribute('aria-controls');
      Array.prototype.forEach.call(root.querySelectorAll('.leaves-process-steps__tab'), function (btn) {
        btn.setAttribute('aria-selected', btn === tab ? 'true' : 'false');
      });
      Array.prototype.forEach.call(root.querySelectorAll('.leaves-process-steps__panel'), function (panel) {
        panel.hidden = panel.id !== id;
      });
    });
  }

  function run() {
    var root =
      document.querySelector("[data-section-id='install-steps'] .leaves-process-steps") ||
      document.querySelector('.leaves-process-steps-host .leaves-process-steps');
    if (!root) return;
    wire(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
